"use client";

import Logo from "@/components/logo";
import logoImage from "@public/svg/logo-2.svg";
import { convertToJalaliDateTime } from "@/lib";
import { QRCodeCanvas } from "qrcode.react";
import React from "react";

interface IProps {
  resultContent: string | React.ReactNode;
  title?: string;
  dateTime: string;
  code?: string;
}

const PdfTextTemplate = (props: IProps) => {
  return (
    <>
      <style>
        {`
          @media print {
            .pdf-page {
              page-break-after: always;
              page-break-inside: avoid;
            }
            .pdf-page:last-child {
              page-break-after: auto;
            }
          }
        `}
      </style>
      <section
        className="pdf-page"
        style={{
          position: "relative",
          minHeight: "1100px",
          height: "1100px",
          display: "flex",
          flexDirection: "column",
          margin: "20px",
        }}
      >
        {/* Watermark on every page */}
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            backgroundImage: `url("${logoImage.src}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "contain",
            opacity: 0.04,
            pointerEvents: "none",
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 50,
            flex: "1",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header on every page */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "10px",
              gap: "1rem",
            }}
          >
            <Logo width={80} height={80} src={logoImage} />
            <span
              style={{
                fontSize: "1.25rem",
                fontWeight: "bold",
                marginBottom: "28px",
              }}
            >
              گزارش استعلام رسمی از سامانه نوین وان
            </span>
            {props.dateTime && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "14px" }}>زمان/تاریخ</span>
                <span
                  dir="ltr"
                  style={{ marginTop: "8px", fontWeight: "bold" }}
                >
                  {convertToJalaliDateTime(props.dateTime)}
                </span>
              </div>
            )}
          </div>
          <hr style={{ color: "#ccc" }} />

          {/* Content */}
          <div
            style={{
              marginTop: "2rem",
              flex: "1",
              maxHeight: "800px",
              overflow: "hidden",
            }}
          >
            <h2
              style={{
                textAlign: "center",
                marginTop: "8px",
                marginBottom: "16px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              {props.title}
            </h2>
            <div>{props.resultContent}</div>
          </div>
        </div>

        {/* Footer on every page */}
        <div
          style={{
            width: "100%",
            marginTop: "auto",
            position: "relative",
            zIndex: 50,
          }}
        >
          <hr />
          <footer
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              padding: "1rem",
            }}
          >
            <p style={{ margin: 0, fontSize: "14px", lineHeight: "30px" }}>
              این گزارش توسط سامانه استعلامات نوین وان (novin.one) تولید شده
              است.
              <br />
              اعتبار این استعلام را می‌توانید در بخش <b>
                "تأیید اصالت گزارش"
              </b>{" "}
              سایت بررسی کنید.
            </p>
            {props.code && (
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ color: "#AAAAAA", fontSize: "14px" }}>
                    شناسه اصالت گزارش
                  </span>
                  <span
                    className="text-en"
                    style={{
                      color: "#D32F2F",
                      fontWeight: "bold",
                      fontSize: "26px",
                      letterSpacing: "1px",
                    }}
                  >
                    {props.code}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <div style={{ width: "100px", height: "100px" }}>
                    <QRCodeCanvas
                      value={`https://novin.one/inquiry-validity?code=${props.code}`}
                      size={100}
                      level="H"
                      marginSize={3}
                    />
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      left: "-40px",
                      top: "50%",
                      transform: "translateY(-50%) rotate(-90deg)",
                      transformOrigin: "center center",
                      fontSize: "12px",
                      color: "#AAAAAA",
                      whiteSpace: "nowrap",
                    }}
                  >
                    اسکن کنید
                  </div>
                </div>
              </div>
            )}
          </footer>
        </div>
      </section>
    </>
  );
};
export default PdfTextTemplate;
